/**
 * Paletas de cor da conta. Compartilha o cache entre o editor global e a barra dos elementos.
 */
import { API_BASE } from '../config/api';

export const MAX_PALETTES = 12;
export const MAX_COLORS = 8;

export const EMPTY_PALETTES = { palettes: [], activePaletteId: '' };

function authToken() {
    try {
        return localStorage.getItem('gepetto_token') || sessionStorage.getItem('gepetto_token') || '';
    } catch {
        return '';
    }
}

export function newPaletteId() {
    if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
        return crypto.randomUUID().replace(/-/g, '').slice(0, 16);
    }
    return `p${Date.now().toString(36)}${Math.random().toString(36).slice(2, 8)}`;
}

export function normalizeHex(raw) {
    const s = String(raw || '').trim();
    const full = s.match(/^#([0-9a-fA-F]{6})$/);
    if (full) return `#${full[1].toLowerCase()}`;
    const short = s.match(/^#([0-9a-fA-F]{3})$/);
    if (!short) return null;
    const [a, b, c] = short[1].toLowerCase();
    return `#${a}${a}${b}${b}${c}${c}`;
}

let cache = null;
let inflight = null;
const listeners = new Set();

function emit() {
    const snapshot = cache || EMPTY_PALETTES;
    listeners.forEach((fn) => fn(snapshot));
}

export function subscribeColorPalettes(fn) {
    listeners.add(fn);
    return () => listeners.delete(fn);
}

export function getColorPalettes() {
    return cache || EMPTY_PALETTES;
}

export async function loadColorPalettes() {
    if (cache) return cache;
    if (inflight) return inflight;
    const token = authToken();
    if (!token) {
        cache = EMPTY_PALETTES;
        emit();
        return cache;
    }
    inflight = fetch(`${API_BASE}/me/color-palettes`, {
        headers: { Authorization: `Bearer ${token}` },
    })
        .then(async (r) => {
            const d = await r.json().catch(() => ({}));
            if (!r.ok) throw new Error(d.error || 'load');
            cache = {
                palettes: Array.isArray(d.palettes) ? d.palettes : [],
                activePaletteId: d.activePaletteId || '',
            };
            emit();
            return cache;
        })
        .finally(() => {
            inflight = null;
        });
    return inflight;
}

/** Grava na conta. Se o cache mudou durante o envio, a resposta antiga não pisa na edição nova. */
export async function persistColorPalettes(next) {
    const sent = JSON.stringify(next);
    cache = next;
    emit();
    const token = authToken();
    if (!token) throw new Error('auth');
    const r = await fetch(`${API_BASE}/me/color-palettes`, {
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
        },
        body: sent,
    });
    const d = await r.json().catch(() => ({}));
    if (!r.ok) throw new Error(d.error || 'save');
    if (JSON.stringify(cache) !== sent) return cache;
    cache = {
        palettes: Array.isArray(d.palettes) ? d.palettes : next.palettes,
        activePaletteId: d.activePaletteId || '',
    };
    emit();
    return cache;
}
